import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { documentShape } from 'helpers/shared_types';
import { formatDatetime } from 'helpers/timezone';
import { downloadDocument } from 'helpers/document';

import { TYPES } from 'config/document';

import { ReactComponent as DownloadSVG } from '../../icons/arrow-down-tray.svg';

const DocumentsCard = ({ data }) => {
  const history = useHistory();

  const onDownload = async (doc) => {
    await downloadDocument(doc.id, doc);
  };

  if (data.length === 0) return null;

  return (
    <div className="w-100 flex flex-column items-start justify-between">
      <div className="w-100">
        <section className="apps-grid-container th-active-users">
          <span className="apps-grid-title">Documents</span>
          <div className="apps-grid">
            {data.map((a) => {
              let createdBy;

              if (a.user) {
                const role = a.user.role;
                createdBy = [a.user[role].firstName, a.user[role].lastName]
                  .filter(Boolean)
                  .join(' ');
              }

              return (
                <div key={a.id} className="apps-grid-cell mw-100vw-m">
                  <article className="apps-card-app">
                    <div
                      className="apps-card-left flex-auto pointer"
                      onClick={() => history.push(`/documents/${a.id}`)}
                    >
                      <div className="apps-card-meta">
                        <h3 className="apps-card-app-title">
                          {TYPES.find((t) => t.id === a.type).label}
                        </h3>
                        <p className="apps-card-app-desc">
                          Created at: {formatDatetime(a.createdAt)}
                        </p>
                        {createdBy && (
                          <p className="apps-card-app-desc">
                            Created by: {createdBy}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="apps-card-right">
                      {a.signatureStatus === 'signed' && (
                        <div className="mr5 flex">
                          <span className="th-badge th-badge-green">
                            {a.signatureStatus}
                          </span>
                        </div>
                      )}
                      <div className="mr5 flex">
                        <DownloadSVG
                          data-rh="Download"
                          className="h6 w6 pointer"
                          onClick={() => onDownload(a)}
                        />
                      </div>
                    </div>
                  </article>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
};

DocumentsCard.propTypes = {
  data: PropTypes.arrayOf(documentShape),
};

export default DocumentsCard;
